import { createSelector } from "reselect"
import { capitalize } from "lodash"
import { getFactorCategory } from "modules/factor-trends/selectors/factors"
import { getStartDate, getEndDate } from "modules/factor-trends/selectors/dates"

export const getFileName = createSelector(
  [getFactorCategory, getStartDate, getEndDate],
  (category, startDate, endDate) => `Factor Trends Performance ${capitalize(category)} Factors ${startDate} - ${endDate}`,
)
